import { QuizGrade } from "src/firebase/FirestoreClient";

export default function isQuizGradeGuard(obj: unknown): obj is QuizGrade {
  const quizGrade = obj as QuizGrade;
  const baseValidation =
    typeof quizGrade?.uid === "string" &&
    (quizGrade?.quizId === undefined || typeof quizGrade?.quizId === "string") &&
    typeof quizGrade?.grade === "number" &&
    typeof quizGrade?.totalQuestions === "number" &&
    typeof quizGrade?.totalCorrectAnswers === "number";

  // Check optional fields - they should be strings if present, undefined if not
  const optionalFieldsValid =
    (quizGrade?.quizType === undefined ||
      typeof quizGrade?.quizType === "string") &&
    (quizGrade?.quizCategory === undefined ||
      typeof quizGrade?.quizCategory === "string");

  // gradeReport is optional - if present, must be an array
  const gradeReportValid =
    quizGrade?.gradeReport === undefined ||
    Array.isArray(quizGrade?.gradeReport);

  return baseValidation && optionalFieldsValid && gradeReportValid;
}
